// ============================================================================
// dataTypes/liveStreamManagment/canvasPipeline/types.ts
// Types du pipeline de compositing canvas.
//
// Le CanvasPipeline dessine sur un <canvas> :
//   1. Le fond (source vidéo active du SourceRegistry)
//   2. Les images overlay à la demande
//   3. (futur) Les incrustations de scènes — étape 5
//
// Il produit un MediaStream via captureStream() envoyé au transport WHIP.
// ============================================================================

// ─── Image overlay (système actuel conservé) ──────────────────────────────────

export interface ImageOverlay {
  id:      string;
  url:     string;
  x:       number;   // % (0–100)
  y:       number;   // % (0–100)
  width:   number;   // % (0–100)
  height:  number;   // % (0–100)
  opacity: number;   // 0–1
}

// ─── Configuration du pipeline ────────────────────────────────────────────────

export interface CanvasPipelineConfig {
  /** Largeur du canvas de sortie (défaut 1920) */
  width:     number;
  /** Hauteur du canvas de sortie (défaut 1080) */
  height:    number;
  /** FPS cible de la boucle de compositing (défaut 25, aligné sur le -r 25 CFR de la chaîne ffmpeg aval) */
  targetFps: number;
}

export const DEFAULT_CANVAS_CONFIG: CanvasPipelineConfig = {
  width:     1920,
  height:    1080,
  targetFps: 25,
};

// ─── État du pipeline ─────────────────────────────────────────────────────────

export type CanvasPipelineState = 'idle' | 'running' | 'stopped';

// ─── Événements ───────────────────────────────────────────────────────────────

export type CanvasEventType =
  | 'started'
  | 'stopped'
  | 'source-changed'
  | 'overlay-changed';

export interface CanvasEvent {
  type:   CanvasEventType;
  detail?: any;
}

export type CanvasEventListener = (event: CanvasEvent) => void;
